






























import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { CategoryFacetDto } from '@/api';

@Component({})
export default class CategoryFilter extends Vue {
  @Model('change', {type: String})
  private category!: string;

  @Prop({required: false})
  private searchString?: string;

  @Prop({required: true})
  private parentCategoryFacets!: CategoryFacetDto[];

  @Prop({required: true})
  private childCategoryFacets!: CategoryFacetDto[];

  get hasParent() {
    return this.parentCategoryFacets.length > 1;
  }

  get hasCurrentCategory() {
    return this.parentCategoryFacets.length > 0;
  }

  get currentHeader() {
    if (this.searchString && this.searchString.length > 0) {
      return this.$t('message.search.resultsFor', {searchString: this.searchString});
    }

    return this.currentCategory?.category?.name;
  }

  get currentResultCount() {
    if (this.currentCategory) {
      return this.currentCategory.resultCount;
    }

    return this.childCategoryFacets
      .map((childCategory) => childCategory.resultCount || 0)
      .reduce((sum, next) => (sum + next), 0);
  }

  get currentCategory(): CategoryFacetDto | null {
    return this.hasCurrentCategory ? this.parentCategoryFacets[this.parentCategoryFacets.length - 1] : null;
  }

  get parentCategory(): CategoryFacetDto | null {
    return this.hasParent ? this.parentCategoryFacets[this.parentCategoryFacets.length - 2] : null;
  }

  public async navigateCategoryUp() {
    this.$emit('change', this.parentCategory ? this.parentCategory.category?.id : '');
  }

  public async navigateToCategory(categoryId: string) {
    this.$emit('change', categoryId);
  }
}
